// cleaned: removed unused React import

export default function SupportIndex() {
  return (
    <section className="section">
      <h1 className="page-title">Support</h1>
      <p className="page-subtitle">If you need help, contact us via the following channels:</p>
      <div className="card">
        <ul>
          <li>
            Email: <a href="mailto:support@nordicscreen.com">support@nordicscreen.com</a>
          </li>
          <li>Phone: +45 00 00 00 00</li>
          <li>
            Website: <a href="https://www.nordicscreen.dk" target="_blank" rel="noreferrer">nordicscreen.dk</a>
          </li>
        </ul>
      </div>
    </section>
  )
}
